import { CurrencyService } from "appworks/services/currency/currency-service";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { TotalStakeTextControl } from "appworks/ui/controls/standard/text/total-stake-text-control";
import { gameiomModel } from "gameiom/model/gameiom-model";
import { slotModel } from "slotworks/model/slot-model";
import { SlotBetService } from "slotworks/services/bet/slot-bet-service";

export class AgsTotalStakeTextControl extends TotalStakeTextControl {
    protected updateStake() {
        const freeBet = slotModel.read().bet.freeBet;

        if (freeBet) {
            this.label.setText(Services.get(TranslationsService).get("free_play"));
        } else {
            const shouldDisplayTrailingDecimals = gameiomModel.shouldDisplayCredits() ? false : gameiomModel.displayWholeStakeAsDecimal;
            const totalStake = Services.get(CurrencyService).format(Services.get(SlotBetService).getTotalStake(), shouldDisplayTrailingDecimals, gameiomModel.shouldDisplayCredits());
            this.label.setText(totalStake);
        }
    }
}
